var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetapparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 57,
    viewBox: "0 0 37 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2705 0.929521C35.0865 4.25097 40.7144 19.0947 31.4577 24.6833C28.8359 26.2662 22.8252 25.6648 22.5622 21.6312C22.2116 16.2525 29.965 17.7203 32.203 20.2698C38.0985 26.9862 34.1086 38.253 28.6282 43.8084C24.0258 48.4738 17.2756 50.524 10.9704 51.4494C8.01278 51.8835 5.49213 51.1527 2.44184 51.2149C-2.00147 51.6125 4.0545 53.3237 5.98883 54.797C9.94124 57.8075 2.43087 52.7951 1.06212 51.7651C1.06928 50.184 5.61231 45.6264 7.42944 43.6427",
    stroke: "#32CCCC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetapparrow);
export default __webpack_public_path__ + "static/media/getapparrow.7eba0e5f3dfbe74725d043e3bd6d4390.svg";
export { ForwardRef as ReactComponent };